// CART BADGE
// ==========

import axios from 'axios';

class CartBadge {
  constructor(selector) {
    this.badge = document.querySelector(selector);
  }

  refreshWithAPI() {
    axios('/kosar/tartalom')
      .then((response) => {
        this.set(response.data);
        return response.data;
      });
    return null;
  }

  refresh() {
    const numberOfCartItems = parseInt(localStorage.getItem('NumberOfCartItems'), 10);
    this.set(numberOfCartItems);
    return numberOfCartItems;
  }

  set(value) {
    if (this.badge !== null) {
      this.badge.textContent = (value === 0) ? '' : value;
    }
  }
}

window.cartbadge = new CartBadge('.cart-item-count');

export default CartBadge;
